// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1zvpM","inputDescription":"styles_inputDescription__3-B9F"};